import { render, staticRenderFns } from "./detailsSupplierSupplyList.vue?vue&type=template&id=45a9d5c2&scoped=true"
import script from "./detailsSupplierSupplyList.vue?vue&type=script&lang=js"
export * from "./detailsSupplierSupplyList.vue?vue&type=script&lang=js"
import style0 from "./detailsSupplierSupplyList.vue?vue&type=style&index=0&id=45a9d5c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a9d5c2",
  null
  
)

export default component.exports